<template>
  <BreadcrumbCL
    :all-white="allWhite"
    :full-background="fullBackground"
    :items="items"
    :with-brodos="withBrodos"
    home-name="Telekom Zubehörshop"
    :class="{ 'breadcrumb-cl--no-padding': noPadding }"
  />
</template>

<script setup lang="ts">
import { Breadcrumb as BreadcrumbCL } from '@i22team/td-longtail-vue-components';
import type { LocationQueryRaw } from 'vue-router';

export type BreadcrumbItem = {
  to?:
    | string
    | {
        path: string;
        query: LocationQueryRaw;
      };
  label: string;
};

export type BreadcrumbProps = {
  items?: BreadcrumbItem[];
  noPadding?: boolean;
  fullBackground?: boolean;
  allWhite?: boolean;
  withBrodos?: boolean;
};

withDefaults(defineProps<BreadcrumbProps>(), {
  items: undefined,
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;
.breadcrumb-cl {
  &--no-padding {
    padding-inline: 0;
  }
}
</style>
